import { Injectable } from '@angular/core';

import { delayFor } from 'app/core/utilities/async-utils';
import { Loggable } from 'app/utils/logging/loggable';
import { OutgoingMessageType, TeleportMessage } from 'messages/websocket.messages';

import { Player } from '../social-pixi-canvas/player';

import { WebsocketService } from './websocket.service';

@Injectable({
  providedIn: 'root',
})
export class TeleportService extends Loggable {
  public teleportEngaged = false;

  public constructor(private websocketService: WebsocketService) {
    super();
    this.setDisplayName('TeleportService');
  }

  public onTeleport(teleportX?: string, teleportY?: string): void {
    const msg: TeleportMessage = {
      t: OutgoingMessageType.TELEPORT,
      x: Number(teleportX),
      y: Number(teleportY),
    };

    this.info('Teleporting to', msg);
    this.websocketService.sendMessage(msg);
  }

  public async teleport(mainPlayer: Player, x: number, y: number): Promise<void> {
    this.teleportEngaged = true;
    await delayFor(1500);
    if (mainPlayer) {
      mainPlayer.fadeOut(1500, 0);
      await delayFor(1500);
      try {
        mainPlayer.fadeIn(1500);
        this.onTeleport(x.toString(), y.toString());
        this.teleportEngaged = false;
      } catch (e) {
        mainPlayer.fadeIn(1500);
        this.teleportEngaged = false;
        this.error('Failed to teleport user to other participant', e);
      }
    }
  }
}
